import MazPhoneNumberInput from 'maz-ui/components/MazPhoneNumberInput'
export default defineNuxtPlugin(nuxtApp => {
  nuxtApp.vueApp.component('maz-phone-number-input', MazPhoneNumberInput)
})
